import { useEffect, useState } from "react";

import styled from "styled-components";

import FnrSlides from "UI/FnrSlides";
import FnrTypography from "UI/FnrTypography";

import { hoverTextKeys, useHoverTextKey } from "./accountAndSettingsStore";

const hoverKeyToText = {
  [hoverTextKeys.importManager]: "Background Tasks",
  [hoverTextKeys.dashboard]: "Action Center",
  [hoverTextKeys.settings]: "Settings",
  [hoverTextKeys.help]: "Help",
  [hoverTextKeys.logout]: "Logout",
};

const hoverTextConfig = [
  { key: "hide", value: () => null },
  {
    key: "show",
    value: ({ text, ...props }) => (
      <CenteringDiv>
        <FnrTypography {...props}>{text}</FnrTypography>
      </CenteringDiv>
    ),
  },
];

const CenteringDiv = styled.div`
  display: flex;
  justify-content: center;
  transform: scale(0.7);
`;

const HoverText = () => {
  const [hoverTextKey] = useHoverTextKey();

  const [text, setText] = useState("");

  useEffect(() => {
    if (hoverTextKey !== hoverTextKeys.noHover)
      setText(hoverKeyToText[hoverTextKey]);
  }, [hoverTextKey]);

  return (
    <SetHeight>
      <FnrSlides
        activeKey={hoverTextKey === hoverTextKeys.noHover ? "hide" : "show"}
        text={text}
        components={hoverTextConfig}
        axis="y"
        color="textLight"
        size="xs"
        noWrap
        clip={false}
        fullWidth
        variant="subtle"
        contentSpring
      />
    </SetHeight>
  );
};

const SetHeight = styled.div`
  height: 14px;
  width: 100%;
  opacity: 0.65;
  position: absolute;
  bottom: 125%;
  left: 0;
  pointer-events: none;
`;

export default HoverText;
